module.exports = __webpack_public_path__ + "static/client16-90c512eba4c2e29ffb403229e55cd893.png";